__turbopack_context__.v({
  "addBtn": "LayoutAndWindowsPanel-module__imHMha__addBtn",
  "areaBadge": "LayoutAndWindowsPanel-module__imHMha__areaBadge",
  "areaBtn": "LayoutAndWindowsPanel-module__imHMha__areaBtn",
  "areaDevSymbol": "LayoutAndWindowsPanel-module__imHMha__areaDevSymbol",
  "areaIcon": "LayoutAndWindowsPanel-module__imHMha__areaIcon",
  "areaItem": "LayoutAndWindowsPanel-module__imHMha__areaItem",
  "areaList": "LayoutAndWindowsPanel-module__imHMha__areaList",
  "areaName": "LayoutAndWindowsPanel-module__imHMha__areaName",
  "body": "LayoutAndWindowsPanel-module__imHMha__body",
  "closeBtn": "LayoutAndWindowsPanel-module__imHMha__closeBtn",
  "colHeader": "LayoutAndWindowsPanel-module__imHMha__colHeader",
  "colHint": "LayoutAndWindowsPanel-module__imHMha__colHint",
  "colSubLabel": "LayoutAndWindowsPanel-module__imHMha__colSubLabel",
  "colTitle": "LayoutAndWindowsPanel-module__imHMha__colTitle",
  "column": "LayoutAndWindowsPanel-module__imHMha__column",
  "columnInnerCell": "LayoutAndWindowsPanel-module__imHMha__columnInnerCell",
  "columnInnerGrid": "LayoutAndWindowsPanel-module__imHMha__columnInnerGrid",
  "columnInnerGridSingle": "LayoutAndWindowsPanel-module__imHMha__columnInnerGridSingle",
  "columns": "LayoutAndWindowsPanel-module__imHMha__columns",
  "componentFilter": "LayoutAndWindowsPanel-module__imHMha__componentFilter",
  "defaultActionsRow": "LayoutAndWindowsPanel-module__imHMha__defaultActionsRow",
  "detailActionBtn": "LayoutAndWindowsPanel-module__imHMha__detailActionBtn",
  "detailActionBtnDanger": "LayoutAndWindowsPanel-module__imHMha__detailActionBtnDanger",
  "detailActionBtnDisabled": "LayoutAndWindowsPanel-module__imHMha__detailActionBtnDisabled",
  "dropHint": "LayoutAndWindowsPanel-module__imHMha__dropHint",
  "dropHintIcon": "LayoutAndWindowsPanel-module__imHMha__dropHintIcon",
  "emptyHint": "LayoutAndWindowsPanel-module__imHMha__emptyHint",
  "expandIn": "LayoutAndWindowsPanel-module__imHMha__expandIn",
  "expandedActions": "LayoutAndWindowsPanel-module__imHMha__expandedActions",
  "expandedComponent": "LayoutAndWindowsPanel-module__imHMha__expandedComponent",
  "expandedHeader": "LayoutAndWindowsPanel-module__imHMha__expandedHeader",
  "expandedHint": "LayoutAndWindowsPanel-module__imHMha__expandedHint",
  "expandedIcon": "LayoutAndWindowsPanel-module__imHMha__expandedIcon",
  "expandedName": "LayoutAndWindowsPanel-module__imHMha__expandedName",
  "expandedNoteBtn": "LayoutAndWindowsPanel-module__imHMha__expandedNoteBtn",
  "expandedNoteBtnDisabled": "LayoutAndWindowsPanel-module__imHMha__expandedNoteBtnDisabled",
  "expandedTitles": "LayoutAndWindowsPanel-module__imHMha__expandedTitles",
  "filterBar": "LayoutAndWindowsPanel-module__imHMha__filterBar",
  "layoutSelectRow": "LayoutAndWindowsPanel-module__imHMha__layoutSelectRow",
  "libraryBody": "LayoutAndWindowsPanel-module__imHMha__libraryBody",
  "map": "LayoutAndWindowsPanel-module__imHMha__map",
  "mapArea": "LayoutAndWindowsPanel-module__imHMha__mapArea",
  "mapAreaBlocked": "LayoutAndWindowsPanel-module__imHMha__mapAreaBlocked",
  "mapAreaBlockedHint": "LayoutAndWindowsPanel-module__imHMha__mapAreaBlockedHint",
  "mapAreaBlockedIcon": "LayoutAndWindowsPanel-module__imHMha__mapAreaBlockedIcon",
  "mapAreaCompatible": "LayoutAndWindowsPanel-module__imHMha__mapAreaCompatible",
  "mapAreaDisabled": "LayoutAndWindowsPanel-module__imHMha__mapAreaDisabled",
  "mapAreaDisabledHint": "LayoutAndWindowsPanel-module__imHMha__mapAreaDisabledHint",
  "mapAreaDragOver": "LayoutAndWindowsPanel-module__imHMha__mapAreaDragOver",
  "mapAreaEmpty": "LayoutAndWindowsPanel-module__imHMha__mapAreaEmpty",
  "mapAreaHeader": "LayoutAndWindowsPanel-module__imHMha__mapAreaHeader",
  "mapAreaIncompatible": "LayoutAndWindowsPanel-module__imHMha__mapAreaIncompatible",
  "mapAreaLabel": "LayoutAndWindowsPanel-module__imHMha__mapAreaLabel",
  "mapAreaToggle": "LayoutAndWindowsPanel-module__imHMha__mapAreaToggle",
  "mapAreaToggleDisabled": "LayoutAndWindowsPanel-module__imHMha__mapAreaToggleDisabled",
  "mapAreaWindows": "LayoutAndWindowsPanel-module__imHMha__mapAreaWindows",
  "mapCancelBtn": "LayoutAndWindowsPanel-module__imHMha__mapCancelBtn",
  "mapCommitBar": "LayoutAndWindowsPanel-module__imHMha__mapCommitBar",
  "mapCommitBtn": "LayoutAndWindowsPanel-module__imHMha__mapCommitBtn",
  "mapCommitIcon": "LayoutAndWindowsPanel-module__imHMha__mapCommitIcon",
  "mapCommitMessage": "LayoutAndWindowsPanel-module__imHMha__mapCommitMessage",
  "mapEmpty": "LayoutAndWindowsPanel-module__imHMha__mapEmpty",
  "mapFooterAreas": "LayoutAndWindowsPanel-module__imHMha__mapFooterAreas",
  "mapFooterLogo": "LayoutAndWindowsPanel-module__imHMha__mapFooterLogo",
  "mapFooterLogoImg": "LayoutAndWindowsPanel-module__imHMha__mapFooterLogoImg",
  "mapHeaderLogo": "LayoutAndWindowsPanel-module__imHMha__mapHeaderLogo",
  "mapHeaderLogoImg": "LayoutAndWindowsPanel-module__imHMha__mapHeaderLogoImg",
  "mapRow": "LayoutAndWindowsPanel-module__imHMha__mapRow",
  "mapRowBodyCatalogSingle": "LayoutAndWindowsPanel-module__imHMha__mapRowBodyCatalogSingle",
  "mapSaving": "LayoutAndWindowsPanel-module__imHMha__mapSaving",
  "mapSavingStripes": "LayoutAndWindowsPanel-module__imHMha__mapSavingStripes",
  "mapSection": "LayoutAndWindowsPanel-module__imHMha__mapSection",
  "mapSectionBody": "LayoutAndWindowsPanel-module__imHMha__mapSectionBody",
  "mapSectionLabel": "LayoutAndWindowsPanel-module__imHMha__mapSectionLabel",
  "mapWindow": "LayoutAndWindowsPanel-module__imHMha__mapWindow",
  "mapWindowDrag": "LayoutAndWindowsPanel-module__imHMha__mapWindowDrag",
  "mapWindowDragging": "LayoutAndWindowsPanel-module__imHMha__mapWindowDragging",
  "mapWindowExpandIn": "LayoutAndWindowsPanel-module__imHMha__mapWindowExpandIn",
  "mapWindowExpanded": "LayoutAndWindowsPanel-module__imHMha__mapWindowExpanded",
  "mapWindowIcon": "LayoutAndWindowsPanel-module__imHMha__mapWindowIcon",
  "mapWindowInsertAfter": "LayoutAndWindowsPanel-module__imHMha__mapWindowInsertAfter",
  "mapWindowInsertBefore": "LayoutAndWindowsPanel-module__imHMha__mapWindowInsertBefore",
  "mapWindowName": "LayoutAndWindowsPanel-module__imHMha__mapWindowName",
  "mapWindowRemove": "LayoutAndWindowsPanel-module__imHMha__mapWindowRemove",
  "panel": "LayoutAndWindowsPanel-module__imHMha__panel",
  "previewHint": "LayoutAndWindowsPanel-module__imHMha__previewHint",
  "previewHintArrow": "LayoutAndWindowsPanel-module__imHMha__previewHintArrow",
  "previewHintBounce": "LayoutAndWindowsPanel-module__imHMha__previewHintBounce",
  "previewHintText": "LayoutAndWindowsPanel-module__imHMha__previewHintText",
  "previewModeBanner": "LayoutAndWindowsPanel-module__imHMha__previewModeBanner",
  "previewModeBannerBtn": "LayoutAndWindowsPanel-module__imHMha__previewModeBannerBtn",
  "previewModeBannerText": "LayoutAndWindowsPanel-module__imHMha__previewModeBannerText",
  "previewToggleBtn": "LayoutAndWindowsPanel-module__imHMha__previewToggleBtn",
  "resetDefaultsBtn": "LayoutAndWindowsPanel-module__imHMha__resetDefaultsBtn",
  "saveDefaultBtn": "LayoutAndWindowsPanel-module__imHMha__saveDefaultBtn",
  "scopeFieldset": "LayoutAndWindowsPanel-module__imHMha__scopeFieldset",
  "scopeLegend": "LayoutAndWindowsPanel-module__imHMha__scopeLegend",
  "scopeOption": "LayoutAndWindowsPanel-module__imHMha__scopeOption",
  "scopeOptionHint": "LayoutAndWindowsPanel-module__imHMha__scopeOptionHint",
  "scopeOptionLabel": "LayoutAndWindowsPanel-module__imHMha__scopeOptionLabel",
  "search": "LayoutAndWindowsPanel-module__imHMha__search",
  "searchIcon": "LayoutAndWindowsPanel-module__imHMha__searchIcon",
  "searchWrap": "LayoutAndWindowsPanel-module__imHMha__searchWrap",
  "sectionCount": "LayoutAndWindowsPanel-module__imHMha__sectionCount",
  "sectionToggle": "LayoutAndWindowsPanel-module__imHMha__sectionToggle",
  "sectionToggleIcon": "LayoutAndWindowsPanel-module__imHMha__sectionToggleIcon",
  "select": "LayoutAndWindowsPanel-module__imHMha__select",
  "slideDown": "LayoutAndWindowsPanel-module__imHMha__slideDown",
  "stateBanner": "LayoutAndWindowsPanel-module__imHMha__stateBanner",
  "stateBannerIcon": "LayoutAndWindowsPanel-module__imHMha__stateBannerIcon",
  "stateBannerInfo": "LayoutAndWindowsPanel-module__imHMha__stateBannerInfo",
  "stateBannerWarning": "LayoutAndWindowsPanel-module__imHMha__stateBannerWarning",
  "windowBox": "LayoutAndWindowsPanel-module__imHMha__windowBox",
  "windowBoxDisabled": "LayoutAndWindowsPanel-module__imHMha__windowBoxDisabled",
  "windowBoxExpanded": "LayoutAndWindowsPanel-module__imHMha__windowBoxExpanded",
  "windowComponent": "LayoutAndWindowsPanel-module__imHMha__windowComponent",
  "windowGrid": "LayoutAndWindowsPanel-module__imHMha__windowGrid",
  "windowIcon": "LayoutAndWindowsPanel-module__imHMha__windowIcon",
  "windowName": "LayoutAndWindowsPanel-module__imHMha__windowName",
});
